import React from 'react';
import PropTypes from 'prop-types';
import TableHeader from './TableHeader';
import TableBody from './TableBody';
import { StyledTable } from './Table.styles';

const Table = ({ borderColor, className, noHeader, dataCy = 'table', dataTestId = 'table', ...props }) => (
  <StyledTable data-cy={dataCy} data-testid={dataTestId} {...{ borderColor, className }}>
    {!noHeader && <TableHeader {...props} />}
    <TableBody {...props} />
  </StyledTable>
);

Table.propTypes = {
  noHeader: PropTypes.bool,
  borderColor: PropTypes.object,
  headerColor: PropTypes.object,
  headerBackground: PropTypes.object,
  alternateBackground: PropTypes.object,
  formatHeader: PropTypes.func,
  dataCy: PropTypes.string,
  dataTestId: PropTypes.string,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      format: PropTypes.func,
      key: PropTypes.string.isRequired
    }).isRequired
  ),
  className: PropTypes.string,
  rows: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  doAlternate: PropTypes.bool
};

export default Table;
